import { BookingType } from '@shared/transactions-types';

import { isBookingType } from './isBookingType';

export const isTaxPayment = isBookingType(
    BookingType.NBFAMT,
    BookingType.MBFAMT,
    BookingType.GEFAMT,
    BookingType.TAFAMT,
    BookingType.TPPFAMT,
);
